export default class Utilities {
  static sortParties(parties: [any?]): [any?] {
    const order = [
      'CDU',
      'GRÜNE',
      'Freie Wähler',
      'SPD',
      'AfD',
      'FDP',
      'DIE LINKE',
      'ÖDP',
      'PIRATEN',
      'KLIMALISTE',
    ];
    return parties.sort((a: any, b: any) => {
      let indexA = order.indexOf(a.name);
      let indexB = order.indexOf(b.name);
      if (indexA === -1) indexA = 100;
      if (indexB === -1) indexB = 100;
      return indexA - indexB;
    });
  }

  static setCookie(name: string, value: string, hoursUntilExpires: number) {
    const date = new Date();
    date.setTime(date.getTime() + (hoursUntilExpires * 60 * 60 * 1000));
    const expires = 'expires=' + date.toUTCString();
    document.cookie = name + '=' + value + ';' + expires + ';path=/';
  }

  static getCookie(name: string) {
    const searchedCookie = name + '=';
    const cookiesArray = document.cookie.split(';');

    for (let i = 0; i < cookiesArray.length; i++) {
      let cookie = cookiesArray[i].trim();
      if (cookie.indexOf(searchedCookie) === 0) {
        return true;
      }
    }
    return false;
  }
}
